import React, { useEffect } from 'react';
import Lottie from 'react-lottie'
// import animationData from '../lottie/roading_test.json'
import animationData from '../lottie/roading_release.json'

import '../styles/Loading.scss' 

const Loading = ({}) => {

    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
        }
    };

    useEffect(() => {
        // 100vh調整
        const setHeight = () => {
            let vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--vh', `${vh}px`)
        }
        setHeight();
    });

    return (
        <div className="loading">
            <div className="loading__bg"></div>
            <div className="loading__anim">
                <Lottie options={defaultOptions} className="lottie"/>
            </div>
        </div>
    )
}

export default Loading